module.exports = __webpack_public_path__ + "static/old_tree_head-d17c120729db86de173506708948e88f.png";